import React from 'react';
import Typography from '@bexs/dollar/components/Typography';
import FlexBox from '@bexs/dollar/components/Flex';

const Header: React.FC = () => (
  <FlexBox>
    <Typography as="h5" weight="400" plain>
      Reports
    </Typography>
  </FlexBox>
);

export default Header;
